export default __webpack_public_path__ + "static/media/close_eye.d7313dc9.svg";